
import { useEffect, useState } from 'react';
import Navbar from '../Components/NavBarAirbnbStyle';
import Lateral1 from '../images/lateral1.png';
import Lateral2 from '../images/lateral2.png';
import videoFondo from '../images/videoFondo.mp4';
import { db, storage } from '../Firebase/Firebase';
import { getAuth, createUserWithEmailAndPassword, sendEmailVerification, signOut, signInWithEmailAndPassword } from "firebase/auth";
import appFirebase from "../Firebase/Firebase";
import { getFirestore, getDoc, getDocs, collection, addDoc, setDoc, doc, query, where, updateDoc, deleteDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject, listAll } from "firebase/storage";
import Modal from 'react-modal';
import './users.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as XLSX from 'xlsx';
import NavbarMobileVersion from '../Components/NavBar/NavBarMobileVersion';

const Busquedas = () => {

    const [busquedas, setBusquedas] = useState([]);
    const [clics, setClics] = useState([]);
    const [lugares, setLugares] = useState([]);
    const [membresias, setMembresias] = useState([]);
    const [recomendados, setRecomendados] = useState([]);
    const [tiposEspacios, setTiposEspacios] = useState([]);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchBusquedas = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, "SectoresBuscados"));
            const data = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }));
            setBusquedas(data);
        } catch (err) {
            console.error("Error al obtener los datos:", err);
            setError("Hubo un problema al cargar los datos. Intenta nuevamente.");
        } finally {
            setLoading(false);
        }
    };
    const fetchClics = async () => {
        try {
            // Obtener todos los documentos de la colección 'Interacciones'
            const querySnapshot = await getDocs(collection(db, "Interacciones"));
            const usuariosClics = [];

            querySnapshot.forEach(doc => {
                const userData = doc.data();
                const clicsEspacios = userData?.clics?.Espacios || [];

                // Para cada clic en la sección Espacios, lo agregamos a la lista
                clicsEspacios.forEach(clic => {
                    const fechaHora = clic.fechaHora
                        ? clic.fechaHora.toDate().toLocaleString()  // Convertir el timestamp a formato de fecha legible
                        : "N/A"; // Si no hay fecha, asignar "N/A"

                    usuariosClics.push({
                        usuario: {
                            nombre: userData.nombre || "N/A",
                            apellido: userData.apellido || "N/A",
                            email: userData.email || "N/A",
                        },
                        espacio: clic.nombreEspacio || "N/A",
                        tipoEspacio: clic.tipoEspacio || "N/A",
                        contador: clic.contador || 0,
                        fechaHora: fechaHora, // Mostrar la fecha formateada
                    });
                });
            });

            setClics(usuariosClics);
        } catch (err) {
            console.error("Error al obtener los datos de clics:", err);
            setError("Hubo un problema al cargar los datos. Intenta nuevamente.");
        } finally {
            setLoading(false);
        }
    };
    const fetchLugares = async () => {
        try {
            // Obtener todos los documentos de la colección 'Interacciones'
            const querySnapshot = await getDocs(collection(db, "Interacciones"));
            const usuariosLugares = [];

            querySnapshot.forEach(doc => {
                const userData = doc.data();
                const lugaresArray = userData?.clics?.Lugares || [];

                // Para cada lugar en la sección Lugares, lo agregamos a la lista
                lugaresArray.forEach(lugar => {
                    // Extraemos la fechaHora registrada para el clic en cada lugar
                    const fechaHora = lugar.fechaHora ? lugar.fechaHora.toDate() : null;

                    // Agregar los detalles del lugar y la fechaHora al array
                    usuariosLugares.push({
                        usuario: {
                            nombre: userData.nombre || "N/A",
                            apellido: userData.apellido || "N/A",
                            email: userData.email || "N/A",
                        },
                        nombreLugar: lugar.lugarDetalles?.nombreLugar || "N/A",
                        direccion: lugar.lugarDetalles?.direccion || "N/A",
                        sector: lugar.lugarDetalles?.sector || "N/A",
                        contador: lugar.contador || 0,
                        fechaHora: fechaHora ? fechaHora.toLocaleString() : "N/A", // Convertir la fechaHora a un formato legible
                    });
                });
            });

            setLugares(usuariosLugares);
        } catch (err) {
            console.error("Error al obtener los datos de lugares:", err);
            setError("Hubo un problema al cargar los datos. Intenta nuevamente.");
        } finally {
            setLoading(false);
        }
    };
    const fetchRecomendados = async () => {
        try {
            // Obtener todos los documentos de la colección 'Interacciones'
            const querySnapshot = await getDocs(collection(db, "Interacciones"));
            const usuariosRecomendados = [];

            querySnapshot.forEach(doc => {
                const userData = doc.data();
                const recomendadosArray = userData?.clics?.Recomendados || [];

                // Para cada espacio recomendado en la sección Recomendados, lo agregamos a la lista
                recomendadosArray.forEach(recomendado => {
                    // Extraemos la fechaHora registrada para el clic en cada lugar
                    const fechaHora = recomendado.fechaHora ? recomendado.fechaHora.toDate() : null;
                    usuariosRecomendados.push({
                        usuario: {
                            nombre: userData.nombre || "N/A",
                            apellido: userData.apellido || "N/A",
                            email: userData.email || "N/A",
                        },
                        nombreEspacio: recomendado.nombreEspacio || "N/A",
                        tipoEspacio: recomendado.tipoEspacio || "N/A",
                        contador: recomendado.contador || 0,
                        fechaHora: fechaHora ? fechaHora.toLocaleString() : "N/A", // Convertir la fechaHora a un formato legible

                    });
                });
            });

            setRecomendados(usuariosRecomendados);
        } catch (err) {
            console.error("Error al obtener los datos de recomendados:", err);
            setError("Hubo un problema al cargar los datos. Intenta nuevamente.");
        } finally {
            setLoading(false);
        }
    };
    const fetchTiposEspacios = async () => {
        try {
            // Obtener todos los documentos de la colección 'Interacciones'
            const querySnapshot = await getDocs(collection(db, "Interacciones"));
            const espaciosData = [];

            querySnapshot.forEach(doc => {
                const userData = doc.data();
                const tiposEspaciosArray = userData?.clics?.TiposEspacios || [];

                // Para cada tipo de espacio en la sección TiposEspacios, lo agregamos a la lista
                tiposEspaciosArray.forEach(espacio => {
                    espaciosData.push({
                        usuario: {
                            nombre: userData.nombre || "N/A",
                            apellido: userData.apellido || "N/A",
                            email: userData.email || "N/A",
                        },
                        contador: espacio.contador || 0,
                        idEspacio: espacio.idEspacio || "N/A",
                        timestamp: espacio.timestamp || "N/A",
                        titulo: espacio.titulo || "N/A",
                    });
                });
            });

            setTiposEspacios(espaciosData);
        } catch (err) {
            console.error("Error al obtener los datos de TiposEspacios:", err);
            setError("Hubo un problema al cargar los datos. Intenta nuevamente.");
        } finally {
            setLoading(false);
        }
    };
    const fetchMembresias = async () => {
        try {
            // Obtener todos los documentos de la colección 'Interacciones'
            const querySnapshot = await getDocs(collection(db, "Interacciones"));
            const membresiasData = [];

            querySnapshot.forEach(doc => {
                const userData = doc.data();
                const membresiasMapa = userData?.clics?.Membresias || {};

                // Iterar sobre las claves en el mapa Membresias
                Object.keys(membresiasMapa).forEach(key => {
                    const membresia = membresiasMapa[key];

                    // Convertir `ultimoClic` a una fecha legible si es un Firestore timestamp
                    const ultimoClicTimestamp = membresia.ultimoClic;
                    const ultimoClic = ultimoClicTimestamp?.toDate
                        ? ultimoClicTimestamp.toDate().toLocaleString() // Formato de fecha legible
                        : ultimoClicTimestamp || "N/A";

                    membresiasData.push({
                        usuario: {
                            nombre: userData.nombre || "N/A",
                            apellido: userData.apellido || "N/A",
                            email: userData.email || "N/A",
                        },
                        coinAmount: membresia.coinAmount || 0,
                        contador: membresia.contador || 0,
                        price: membresia.price || 0,
                        ultimoClic, // Fecha legible
                    });
                });
            });

            setMembresias(membresiasData);
        } catch (err) {
            console.error("Error al obtener los datos de Membresías:", err);
            setError("Hubo un problema al cargar los datos. Intenta nuevamente.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBusquedas();
        fetchClics();
        fetchLugares();
        fetchRecomendados();
        fetchTiposEspacios();
        fetchMembresias();

    }, []);

    const exportarExcel = () => {
        // Crear un libro de trabajo (workbook) de Excel
        const wb = XLSX.utils.book_new();

        // Crear una hoja de trabajo con los datos
        const hojaDatos = busquedas.map(busqueda => ({
            Nombre: busqueda.usuario?.nombre || "N/A",
            Apellido: busqueda.usuario?.apellido || "N/A",
            Email: busqueda.usuario?.email || "N/A",
            Ciudad: busqueda.ciudad || "N/A",
            Sector: busqueda.sector || "N/A",
            "Fecha y Hora": busqueda.timestamp ? new Date(busqueda.timestamp).toLocaleString() : "N/A"
        }));

        // Convertir los datos a un formato que Excel pueda entender
        const ws = XLSX.utils.json_to_sheet(hojaDatos);

        // Agregar la hoja al libro de trabajo
        XLSX.utils.book_append_sheet(wb, ws, "Datos");

        // Exportar el libro de trabajo a un archivo Excel
        XLSX.writeFile(wb, "reporte_datos.xlsx");
    };

 const [isDarkMode, setIsDarkMode] = useState(() => {
    try {
      // Intentamos leer valor guardado en localStorage
      const saved = localStorage.getItem('darkMode');
      if (saved !== null) {
        const parsed = JSON.parse(saved);
        if (typeof parsed === 'boolean') return parsed; // Solo si es booleano válido
      }
    } catch (error) {
      // Si JSON.parse falla o localStorage no está disponible, ignoramos el error
      console.warn('Error leyendo localStorage darkMode:', error);
    }

    // Detectar modo oscuro sistema solo si está disponible window.matchMedia
    const prefersDark = typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

    // Detectar hora nocturna (7pm a 6am)
    const hour = new Date().getHours();
    const isNight = hour >= 19 || hour < 6;

    // Retorna true o false seguro
    return prefersDark || isNight;
  });

  // Cargar el tema al inicio (localStorage, sistema u hora)
  useEffect(() => {
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme !== null) {
      setIsDarkMode(JSON.parse(savedTheme));
    } else {
      // Detecta modo oscuro sistema
      const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

      // Detecta modo oscuro por hora (7pm - 6am)
      const hour = new Date().getHours();
      const isNight = hour >= 19 || hour < 6;

      setIsDarkMode(prefersDark || isNight);
    }
  }, []);

  // Guardar la preferencia y aplicar clase al body
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  // Función para cambiar el modo
  const toggleDarkMode = () => setIsDarkMode(!isDarkMode);

    return (
        <div>
            <Navbar isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
            <NavbarMobileVersion isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
            <ToastContainer />

            <div className='center-header-type'>
                <img className='imagenlateral1' src={Lateral1} alt="Lateral" />
                <h1>Busquedas de Sectores</h1>
                <img className='imagenlateral2' src={Lateral2} alt="Lateral" />
            </div>
            <button onClick={exportarExcel} className='btn-spaces'>
                Exportar a Excel
            </button>
            <div className="table-container-type" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr>
                            <th className="table-header">Nombres</th>
                            <th className="table-header">Apellidos</th>
                            <th className="table-header">Email</th>
                            <th className="table-header">Ciudad</th>
                            <th className="table-header">Sector</th>
                            <th className="table-header">Fecha y Hora</th>
                        </tr>
                    </thead>
                    <tbody>
                        {busquedas.length > 0 ? (
                            busquedas.map((busqueda, index) => (
                                <tr key={index} className="table-row">
                                    <td className="table-cell">{busqueda.usuario?.nombre || "N/A"}</td>
                                    <td className="table-cell">{busqueda.usuario?.apellido || "N/A"}</td>
                                    <td className="table-cell">{busqueda.usuario?.email || "N/A"}</td>
                                    <td className="table-cell">{busqueda.ciudad || "N/A"}</td>
                                    <td className="table-cell">{busqueda.sector || "N/A"}</td>
                                    <td className="table-cell">
                                        {busqueda.timestamp
                                            ? new Date(busqueda.timestamp).toLocaleString()
                                            : "N/A"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                                    No se encontraron registros.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <h1>Espacios</h1>
            <div className="table-container-type" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                <div className="table-container-type">
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th className="table-header">Nombre</th>
                                <th className="table-header">Apellido</th>
                                <th className="table-header">Email</th>
                                <th className="table-header">Espacio</th>
                                <th className="table-header">Tipo de Espacio</th>
                                <th className="table-header">Contador de Clics</th>
                                <th className="table-header">Fecha</th>

                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                                        Cargando datos...
                                    </td>
                                </tr>
                            ) : error ? (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                                        {error}
                                    </td>
                                </tr>
                            ) : clics.length > 0 ? (
                                clics.map((clic, index) => (
                                    <tr key={index} className="table-row">
                                        <td className="table-cell">{clic.usuario.nombre}</td>
                                        <td className="table-cell">{clic.usuario.apellido}</td>
                                        <td className="table-cell">{clic.usuario.email}</td>
                                        <td className="table-cell">{clic.espacio}</td>
                                        <td className="table-cell">{clic.tipoEspacio}</td>
                                        <td className="table-cell">{clic.contador}</td>
                                        <td className="table-cell">
                                            {clic.fechaHora
                                                ? new Date(clic.fechaHora).toLocaleString()
                                                : "N/A"}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                                        No se encontraron registros.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <h1>Lugares</h1>
            <div className="table-container-type" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                <div className="table-container-type">
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th className="table-header">Nombre</th>
                                <th className="table-header">Apellido</th>
                                <th className="table-header">Email</th>
                                <th className="table-header">Lugar</th>
                                <th className="table-header">Dirección</th>
                                <th className="table-header">Sector</th>
                                <th className="table-header">Contador de Clics</th>
                                <th className="table-header">Fecha</th>

                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                                        Cargando datos...
                                    </td>
                                </tr>
                            ) : error ? (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                                        {error}
                                    </td>
                                </tr>
                            ) : lugares.length > 0 ? (
                                lugares.map((lugar, index) => (
                                    <tr key={index} className="table-row">
                                        <td className="table-cell">{lugar.usuario.nombre}</td>
                                        <td className="table-cell">{lugar.usuario.apellido}</td>
                                        <td className="table-cell">{lugar.usuario.email}</td>
                                        <td className="table-cell">{lugar.nombreLugar}</td>
                                        <td className="table-cell">{lugar.direccion}</td>
                                        <td className="table-cell">{lugar.sector}</td>
                                        <td className="table-cell">{lugar.contador}</td>
                                        <td className="table-cell">{lugar.fechaHora}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                                        No se encontraron registros.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <h1>Recomendados</h1>
            <div className="table-container-type" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                <div className="table-container-type">
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th className="table-header">Nombre</th>
                                <th className="table-header">Apellido</th>
                                <th className="table-header">Email</th>
                                <th className="table-header">Espacio</th>
                                <th className="table-header">Tipo</th>
                                <th className="table-header">Contador de Clics</th>
                                <th className="table-header">Fecha</th>

                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                                        Cargando datos...
                                    </td>
                                </tr>
                            ) : error ? (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                                        {error}
                                    </td>
                                </tr>
                            ) : recomendados.length > 0 ? (
                                recomendados.map((recomendado, index) => (
                                    <tr key={index} className="table-row">
                                        <td className="table-cell">{recomendado.usuario.nombre}</td>
                                        <td className="table-cell">{recomendado.usuario.apellido}</td>
                                        <td className="table-cell">{recomendado.usuario.email}</td>
                                        <td className="table-cell">{recomendado.nombreEspacio}</td>
                                        <td className="table-cell">{recomendado.tipoEspacio}</td>
                                        <td className="table-cell">{recomendado.contador}</td>
                                        <td className="table-cell">{recomendado.fechaHora}</td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                                        No se encontraron registros.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <h1>Tipo de Espacios</h1>
            <div className="table-container-type" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                <div className="table-container-type">
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th className="table-header">Nombre</th>
                                <th className="table-header">Apellido</th>
                                <th className="table-header">Email</th>
                                <th className="table-header">Título</th>
                                <th className="table-header">ID Espacio</th>
                                <th className="table-header">Contador</th>
                                <th className="table-header">Fecha y Hora</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                                        Cargando datos...
                                    </td>
                                </tr>
                            ) : error ? (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                                        {error}
                                    </td>
                                </tr>
                            ) : tiposEspacios.length > 0 ? (
                                tiposEspacios.map((espacio, index) => (
                                    <tr key={index} className="table-row">
                                        <td className="table-cell">{espacio.usuario.nombre}</td>
                                        <td className="table-cell">{espacio.usuario.apellido}</td>
                                        <td className="table-cell">{espacio.usuario.email}</td>
                                        <td className="table-cell">{espacio.titulo}</td>
                                        <td className="table-cell">{espacio.idEspacio}</td>
                                        <td className="table-cell">{espacio.contador}</td>
                                        <td className="table-cell">
                                            {espacio.timestamp !== "N/A"
                                                ? new Date(espacio.timestamp).toLocaleString()
                                                : "N/A"}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px' }}>
                                        No se encontraron registros.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <h1>Membresias</h1>
            <div className="table-container-type" style={{ maxHeight: '200px', overflowY: 'auto' }}>
                <div className="table-container-type">
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th className="table-header">Nombre</th>
                                <th className="table-header">Apellido</th>
                                <th className="table-header">Email</th>
                                <th className="table-header">Coins</th>
                                <th className="table-header">Valor</th>
                                <th className="table-header">Contador</th>
                                <th className="table-header">Último Clic</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
                                        Cargando datos...
                                    </td>
                                </tr>
                            ) : error ? (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
                                        {error}
                                    </td>
                                </tr>
                            ) : membresias.length > 0 ? (
                                membresias.map((membresia, index) => (
                                    <tr key={index} className="table-row">
                                        <td className="table-cell">{membresia.usuario.nombre}</td>
                                        <td className="table-cell">{membresia.usuario.apellido}</td>
                                        <td className="table-cell">{membresia.usuario.email}</td>
                                        <td className="table-cell">{membresia.coinAmount}</td>
                                        <td className="table-cell">{membresia.price}</td>
                                        <td className="table-cell">{membresia.contador}</td>

                                        <td className="table-cell">
                                            {membresia.ultimoClic !== "N/A"
                                                ? new Date(membresia.ultimoClic).toLocaleString()
                                                : "N/A"}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
                                        No se encontraron registros.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    );
};


export default Busquedas;
